import { useSearchPageZeroIndexedPageNumber } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageZeroIndexedPageNumber";

export const useSearchPageIsOnFirstPage = () => {
  return useSearchPageZeroIndexedPageNumber() === 0;
};
